import { Box, Typography } from "@mui/material";
import strings from "global/constants/StringConstants";
import { AppModal } from "global/components/AppModal";
import styles from "../ContractSearch.styles";
import { fill } from "../ContractSearchHelper";
import { ViewerState } from "../ContractSearchTypes";

interface PassageViewerProps {
  viewer: ViewerState | null;
  onClose: () => void;
  onOpenPdf: (viewer: ViewerState) => void;
}

const viewerMeta = (viewer: ViewerState): string => {
  const copy = strings.contractSearch;
  if (viewer.page == null) return viewer.linesLabel;
  if (!viewer.linesLabel) return fill(copy.viewerPageOnly, { page: viewer.page });
  return fill(copy.viewerMeta, {
    page: viewer.page,
    lines: viewer.linesLabel.replace(/^lines? /, ""),
  });
};

/**
 * The passage the user clicked, in the app's centred modal (a bottom sheet on
 * phones -- `AppModal` handles that): the document name and location in the
 * header, the quote highlighted on a page-like panel, Close and "Open full
 * PDF" in the footer. The PDF action is hidden when the AI has no
 * `sourceRequestId` for the document (unsigned uploads -- plan §10.3).
 */
const PassageViewer = ({ viewer, onClose, onOpenPdf }: PassageViewerProps) => {
  const copy = strings.contractSearch;
  if (!viewer) return null;

  return (
    <AppModal
      open
      onClose={onClose}
      title={viewer.fileName}
      subtitle={viewerMeta(viewer)}
      hideIcon
      size="md"
      cancelLabel={copy.close}
      onCancel={onClose}
      primaryLabel={viewer.sourceRequestId ? copy.openFullPdf : undefined}
      onPrimary={viewer.sourceRequestId ? () => onOpenPdf(viewer) : undefined}
    >
      <Box sx={styles.viewerPage}>
        <Typography component="blockquote" sx={styles.viewerQuote}>
          {viewer.quote}
        </Typography>
      </Box>
    </AppModal>
  );
};

export default PassageViewer;
